/**
 * @Author: brand
 * @Date: 2019-06-26 15:06
 * @Email: brandhuang@qq.com
 */
import ax from '../../axios'

/**
 * 留言
 * @param params
 */
// 留言-首次响应时间
export function getLeavewordFirstResponedDataAPI (params) {
    return ax({
        url: '/wlapi/index/leaveFirstRespond',
        method: 'POST',
        params
    })
}